// Utilitários HTTP do backend falso (modo fake, só em dev — Parte 0.6). Espelham o formato real
// (`application/problem+json`, RFC 9457) para que os componentes tratem erros exatamente como em produção.
import { PROBLEM_JSON } from '@giyus/api-client';

export function jsonResponse(
  body: unknown,
  status = 200,
  extraHeaders?: Record<string, string>,
): Response {
  return new Response(JSON.stringify(body), {
    status,
    headers: { 'content-type': 'application/json', ...extraHeaders },
  });
}

export function noContent(): Response {
  return new Response(null, { status: 204 });
}

export function problemResponse(
  status: number,
  errorCode: string,
  correlationId: string | null,
  extra?: Record<string, unknown>,
): Response {
  return new Response(
    JSON.stringify({
      status,
      errorCode,
      title: errorCode,
      correlationId: correlationId ?? undefined,
      ...extra,
    }),
    {
      status,
      headers: {
        'content-type': PROBLEM_JSON,
        ...(correlationId ? { 'X-Correlation-Id': correlationId } : {}),
      },
    },
  );
}

export class FakeApiError extends Error {
  constructor(
    readonly status: number,
    readonly errorCode: string,
    readonly extra?: Record<string, unknown>,
  ) {
    super(errorCode);
  }
}

export function requireReason(body: unknown, field = 'reason'): string {
  const value = (body as Record<string, unknown> | null)?.[field];
  if (typeof value !== 'string' || value.trim().length === 0) {
    throw new FakeApiError(422, 'PLT_VALIDATION', {
      errors: [{ field, code: 'REQUIRED', message: 'Required.' }],
    });
  }
  return value;
}

export async function readJsonBody(request: Request): Promise<unknown> {
  const text = await request.text();
  if (!text) {
    return {};
  }
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return {};
  }
}
